import { motion } from "framer-motion";

const PARTNERS = ["SAP", "Oracle NetSuite", "Workday", "BambooHR", "Amadeus", "Sabre", "Tally", "Concur"];

const METRICS = [
  { value: "$1.4B+", label: "Travel spend processed annually" },
  { value: "99.4%", label: "Policy compliance rate" },
  { value: "4.2x", label: "Faster expense audit cycle" },
  { value: "140+", label: "Countries & currencies covered" },
];

export const TrustedBy = () => {
  return (
    <section data-testid="trusted-by-section" className="bg-slate-50 py-20">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center font-mono text-[11px] tracking-widest text-slate-500 uppercase">
          Integrates natively with your HRMS, GDS & ERP stack
        </p>

        <div className="mt-8 overflow-hidden relative" data-testid="trusted-by-marquee">
          <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-slate-50 to-transparent z-10" />
          <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-slate-50 to-transparent z-10" />
          <div className="flex w-max animate-marquee gap-16 items-center">
            {[...PARTNERS, ...PARTNERS].map((p, i) => (
              <span
                key={`${p}-${i}`}
                className="font-heading font-bold text-2xl text-slate-300 whitespace-nowrap select-none"
              >
                {p}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 rounded-xl overflow-hidden border border-slate-200">
          {METRICS.map((m, i) => (
            <motion.div
              key={m.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.5 }}
              data-testid={`metric-card-${i}`}
              className="bg-white p-8"
            >
              <p className="font-heading font-extrabold text-3xl text-slate-900">{m.value}</p>
              <p className="mt-2 text-sm text-slate-500">{m.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
